import axios from '../axios'

var EarthFaultProvider = function () {
  return {
    async GetEarthFaultAsync (uniqueid, componentid, field, range) {
      return axios.get('/influx/earthfault/' + uniqueid + '/' + componentid + '/' + field + '/' + range)
    }
  }
}
export default new EarthFaultProvider()



// WEBPACK FOOTER //
// ./src/providers/EarthFaultProvider.js